module.exports = __webpack_public_path__ + "assets/4e079dc2fa77f902cc0398299225e88a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.png
// module id = 393
// module chunks = 1